<main class="ss-container">
  <ss-page-header title="Dashboard" icon="layout-dashboard"></ss-page-header>
</main>
